import * as userActionTypes from "ActionTypes/userActionTypes";
import userInitialState from "InitialStates/userInitialState";

const reducers = {
  setToken: (state, action) => {
    return {
      ...state,
      token: action.token
    };
  },
  setUserData: (state, action) => {
    return {
      ...state,
      data: action.userData
    };
  },
  setAuthStatus: (state, action) => {
    return {
      ...state,
      authStatus: action.authStatus
    };
  }
};

const userReducer = (state = userInitialState, action) => {
  switch (action.type) {
    case userActionTypes.SET_TOKEN:
      return reducers.setToken(state, action);
    case userActionTypes.SET_USER_DATA:
      return reducers.setUserData(state, action);
    case userActionTypes.SET_AUTH_STATUS:
      return reducers.setAuthStatus(state, action);
    default:
      return state;
  }
};

export default userReducer;



// WEBPACK FOOTER //
// ./src/store/reducers/userReducer.js